import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/components/appcomponents/CommonFooter.js");
;
import(/* webpackMode: "eager", webpackExports: ["FrequentlyAskedQuestionView2"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/components/appcomponents/FrequentlyAskedQuestionView.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/components/appcomponents/Layout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/qr-kode/ClientAccordionBehavior.tsx");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/qr-kode/qr-kode.css");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/qr-kode/qr-kode-responsive.css");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/bnefits_qr_img1.png");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/editing_icon.svg");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/enostavna.png");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/memorial-mobile.png");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/mosnter_pic_icon.svg");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/qr_kode_nagrobianke.jpg");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/qr_screenshoot_img.png");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/scan_svg.svg");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/spominov.png");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/visoka.jpg");
;
import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/public/qr-kode/women_and_girl.png");
